var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",staticStyle:{"margin-top":"50px"}},[_c('h2',[_vm._v(" Benvenuto nel gestionale ordini della BST s.r.l. ")])])}]

export { render, staticRenderFns }